import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classNames from 'classnames';
import { Context, ContextProvider, ContextConsumer } from './components/Context';
import AccountDropdown from './components/AccountDropdown';
import AccountMenuItem from './components/AccountMenuItem';
import Avatar from './components/Avatar';
import Content from './components/Content';
import HeaderNav from './components/HeaderNav';
import Logo from './components/Logo';
import NavDropdown from './components/NavDropdown';
import NavMenuButton from './components/NavMenuButton';
import NavMenuDivider from './components/NavMenuDivider';
import NavMenuHeading from './components/NavMenuHeading';
import NavMenuItem from './components/NavMenuItem';
import NavSearch from './components/NavSearch';
import Nav from './components/Nav';
import AppSwitcher from './components/AppSwitcher/AppSwitcher';
import Banner from './components/Banner';
import Section from './components/Section';
import { BasicUserContextProvider } from './components/UserContext/BasicUserContextProvider';
import { SupportDropdown } from './components/SupportDropdown';
export var CommonChrome = /*#__PURE__*/function (_React$Component) {
  _inherits(CommonChrome, _React$Component);

  var _super = _createSuper(CommonChrome);

  function CommonChrome() {
    _classCallCheck(this, CommonChrome);

    return _super.apply(this, arguments);
  }

  _createClass(CommonChrome, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeKey = _this$props.activeKey,
          children = _this$props.children,
          chromeless = _this$props.chromeless,
          className = _this$props.className,
          _this$props$hasSideba = _this$props.hasSidebar,
          hasSidebar = _this$props$hasSideba === void 0 ? true : _this$props$hasSideba,
          links = _this$props.links,
          LinkWrapper = _this$props.LinkWrapper,
          banner = _this$props.banner,
          _this$props$UserConte = _this$props.UserContextProvider,
          UserContextProvider = _this$props$UserConte === void 0 ? BasicUserContextProvider : _this$props$UserConte;
      var hasLinks = this.props.hasLinks || (links || []).length > 0;
      return /*#__PURE__*/React.createElement(UserContextProvider, null, /*#__PURE__*/React.createElement(ContextProvider, {
        activeKey: activeKey,
        banner: banner,
        chromeless: chromeless,
        hasSidebar: hasSidebar,
        links: links,
        hasLinks: hasLinks,
        LinkWrapper: LinkWrapper
      }, /*#__PURE__*/React.createElement(ContextConsumer, null, function (_ref) {
        var chromelessFloating = _ref.chromelessFloating,
            expanded = _ref.expanded,
            banner = _ref.banner;
        return /*#__PURE__*/React.createElement("div", {
          className: classNames('cloud-ui-nav-root', className, {
            chromeless: chromeless,
            floating: chromelessFloating,
            expanded: expanded,
            'with-banner': banner,
            'without-sidebar': !hasSidebar,
            'without-links': !hasLinks
          })
        }, children);
      })));
    }
  }]);

  return CommonChrome;
}(React.Component);

_defineProperty(CommonChrome, "AccountDropdown", AccountDropdown);

_defineProperty(CommonChrome, "AccountMenuItem", AccountMenuItem);

_defineProperty(CommonChrome, "AppSwitcher", AppSwitcher);

_defineProperty(CommonChrome, "Avatar", Avatar);

_defineProperty(CommonChrome, "Content", Content);

_defineProperty(CommonChrome, "HeaderNav", HeaderNav);

_defineProperty(CommonChrome, "Logo", Logo);

_defineProperty(CommonChrome, "Nav", Nav);

_defineProperty(CommonChrome, "NavDropdown", NavDropdown);

_defineProperty(CommonChrome, "NavMenuButton", NavMenuButton);

_defineProperty(CommonChrome, "NavMenuDivider", NavMenuDivider);

_defineProperty(CommonChrome, "NavMenuHeading", NavMenuHeading);

_defineProperty(CommonChrome, "NavMenuItem", NavMenuItem);

_defineProperty(CommonChrome, "NavSearch", NavSearch);

_defineProperty(CommonChrome, "Context", Context);

_defineProperty(CommonChrome, "ContextConsumer", ContextConsumer);

_defineProperty(CommonChrome, "ContextProvider", ContextProvider);

_defineProperty(CommonChrome, "Banner", Banner);

_defineProperty(CommonChrome, "Section", Section);

_defineProperty(CommonChrome, "SupportDropdown", SupportDropdown);

export { AccountDropdown, AccountMenuItem, AppSwitcher, Avatar, Banner, Content, ContextConsumer, ContextProvider, HeaderNav, Logo, Nav, NavDropdown, NavMenuButton, NavMenuDivider, NavMenuHeading, NavMenuItem, NavSearch, Section };
export default CommonChrome;